import Vue from "vue"

const state = {

}

const mutations = {

}

const actions = {
    async fetchPopUps({ dispatch }) {
        const { data, status } = await Vue.axios.get("/popups");
        if (status != 200) {
            await dispatch("generateSnackBarMessage", { message: 'Ocurrió un error al obtener los rubros', type: 'error' })
        };
        return { data, status };
    },
    async createPopUp({ dispatch }, popUp) {
        const formData = new FormData();
        formData.append('file_popups', popUp.file_popups);
        formData.append('link', popUp.link);
        const { data, status } = await Vue.axios.post("/popups", formData);
        if (status != 200 && status != 201) {
            await dispatch("createResponseMessage", { message: data.message || 'Ocurrió un error guardando los datos del rubro', type: 'error' })
        } else {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Se guardó correctamente', type: 'success' })
        }
        return { data, status };
    },
    async updatePopUp({ dispatch }, popUp) {
        // console.log(popUp)
        const formData = new FormData();
        if (popUp.link || popUp.link === '')
            formData.append('link', popUp.link);
        if (popUp.file_popups)
            formData.append('file_popups', popUp.file_popups)

        const { data, status } = await Vue.axios.post(`/popups/${popUp.id}`, formData);
        if (status != 200 && status != 201 && status != 204) {
            await dispatch("createResponseMessage", { message: data.message || 'Ocurrió un error actualizando los datos del rubro', type: 'error' })
        } else {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Se guardó correctamente', type: 'success' })
        }
        return { data, status };
    },
    async removePopUp({ dispatch }, popUp) {
        const { data, status } = await Vue.axios.delete(`/popups/${popUp.id}`);
        if (status != 200 && status != 204) {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Ocurrió un error eliminando al rubro del sistema', type: 'error' })
        } else {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Rubro eliminado correctamente', type: 'success' })
        }
        return { data, status };
    }
}

export default { state, mutations, actions }
